export default __webpack_public_path__ + "static/media/minivan_342053 1.605dc509.svg";